"use client";

import { BannerSection } from "@/components/sections/BannerSection";
import { BlogEventsGrid } from "./sections/BlogEventsGrid";
import { PassedEvents } from "./sections/PassedEvents";
import { BreadcrumbHomepage } from "@/components/sections/BreadcrumbHomepage";

export default function BlogPage() {
  return (
    <>
      <main className="flex min-h-screen max-w-[100vw] flex-col">
        <BannerSection title="Blog & Événements" />
        <BreadcrumbHomepage />
        <BlogEventsGrid />
        <PassedEvents />
      </main>
    </>
  );
}
